import { createSlice } from "@reduxjs/toolkit";
import { thinksToDoReducer } from "./reducer";
import { initialState } from "./initialState";
import { ThinksToDoType } from "./thinksToDoType";
import { addJobClosureRejectCommentAction, approveOrRejectRegularizeAction, getJobClosureListAction, getJobClosureRMListAction, getJobClosureRatingListAction, getRegularizeApprovalPendingListAction, getScheduledUpcomingInterviewsList, getUnApprovedInvoiceCountListAction, getWeeklyApprovedUsersInvoiceEntriesCountAction, sendApprovalStatusAction, singleGetApprovalListAction, singleScheduledUpcomingInterviewsDetailsAction, updateRecruitmentTrackerAction } from "./actions";

export const thinksToDoSlice = createSlice({
  name: "thinkToDo",
  initialState,
  reducers: thinksToDoReducer,
  extraReducers: {
    [getScheduledUpcomingInterviewsList.pending.toString()]: (
      state: ThinksToDoType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getScheduledUpcomingInterviewsList.fulfilled.toString()]: (
      state: ThinksToDoType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        scheduledUpcomingInterviews: result?.result,
        totalCount:result?.total_count

      };
    },
    [getScheduledUpcomingInterviewsList.rejected.toString()]: (
      state: ThinksToDoType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
       [singleScheduledUpcomingInterviewsDetailsAction.pending.toString()]: (
      state: ThinksToDoType
    ) => ({
      ...state,
      fetching: true,
    }),
    [singleScheduledUpcomingInterviewsDetailsAction.fulfilled.toString()]: (
      state: ThinksToDoType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        singleScheduledUpcomingInterviewsDetails: result,
      };
    },
    [singleScheduledUpcomingInterviewsDetailsAction.rejected.toString()]: (
      state: ThinksToDoType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

  [updateRecruitmentTrackerAction.pending.toString()]: (
      state: ThinksToDoType
    ) => ({
      ...state,
      updateFetching: true,
    }),
    [updateRecruitmentTrackerAction.fulfilled.toString()]: (
      state: ThinksToDoType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
          updateFetching: false,
        };
      }
      return {
        ...state,
        updateFetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateRecruitmentTrackerAction.rejected.toString()]: (
      state: ThinksToDoType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
    }),
    ////status
    

    [sendApprovalStatusAction.pending.toString()]: (
      state: ThinksToDoType
    ) => ({
      ...state,
      updateFetching: true,
    }),
    [sendApprovalStatusAction.fulfilled.toString()]: (
      state: ThinksToDoType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
          updateFetching: false,
        };
      }
      return {
        ...state,
        updateFetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [sendApprovalStatusAction.rejected.toString()]: (
      state: ThinksToDoType,
      { error }
    ) => ({
      ...state,
      updateFetching: false,
      success: 0,
      error: error?.message,
    }),


     [singleGetApprovalListAction.pending.toString()]: (
      state: ThinksToDoType
    ) => ({
      ...state,
      updateFetching: true,
    }),
    [singleGetApprovalListAction.fulfilled.toString()]: (
      state: ThinksToDoType,
      { payload }
    ) => {
      const { success, status_code, message,result } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
          updateFetching: false,
        };
      }
      return {
        ...state,
        updateFetching: false,
        statusCode: status_code,
        success,
        message,
        singleApprovalData:result
      };
    },

    [singleGetApprovalListAction.rejected.toString()]: (
      state: ThinksToDoType,
      { error }
    ) => ({
      ...state,
      updateFetching: false,
      success: 0,
      error: error?.message,
    }),
    [getJobClosureListAction.pending.toString()]: (
      state: ThinksToDoType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getJobClosureListAction.fulfilled.toString()]: (
      state: ThinksToDoType,
      { payload }
    ) => {
      const { success, message, result, status_code ,count} = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        jobClosureListData: result,
        jobClosureTotalCount:count

      };
    },
    [getJobClosureListAction.rejected.toString()]: (
      state: ThinksToDoType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }), 

    [addJobClosureRejectCommentAction.pending.toString()]: (
      state: ThinksToDoType
    ) => ({
      ...state,
      updateFetching: true,
    }),
    [addJobClosureRejectCommentAction.fulfilled.toString()]: (
      state: ThinksToDoType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
          updateFetching: false,
        };
      }
      return {
        ...state,
        updateFetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [addJobClosureRejectCommentAction.rejected.toString()]: (
      state: ThinksToDoType,
      { error }
    ) => ({
      ...state,
      updateFetching: false,
      success: 0,
      error: error?.message,
    }),
    // 
    [getJobClosureRMListAction.pending.toString()]: (
      state: ThinksToDoType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getJobClosureRMListAction.fulfilled.toString()]: (
      state: ThinksToDoType,
      { payload }
    ) => {
      const { success, message, result, status_code ,count} = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        jobClosureListForRM: result,
        totalCountRM:count

      };
    },
    [getJobClosureRMListAction.rejected.toString()]: (
      state: ThinksToDoType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }), 
    [getJobClosureRatingListAction.pending.toString()]: (
      state: ThinksToDoType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getJobClosureRatingListAction.fulfilled.toString()]: (
      state: ThinksToDoType,
      { payload }
    ) => {
      const { success, message, result, status_code ,count} = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        jobClosureRatingList: result,
      };
    },
    [getJobClosureRatingListAction.rejected.toString()]: (
      state: ThinksToDoType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }), 
  
    [getUnApprovedInvoiceCountListAction.pending.toString()]: (
      state: ThinksToDoType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getUnApprovedInvoiceCountListAction.fulfilled.toString()]: (
      state: ThinksToDoType,
      { payload }
    ) => {
      const { success, message, result, status_code ,count,is_accounting_in_charge} = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        unApprovedInvoiceCountData: result,
        isAccountingInCharge:is_accounting_in_charge

      };
    },
    [getUnApprovedInvoiceCountListAction.rejected.toString()]: (
      state: ThinksToDoType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }), 
    [getWeeklyApprovedUsersInvoiceEntriesCountAction.pending.toString()]: (
      state: ThinksToDoType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getWeeklyApprovedUsersInvoiceEntriesCountAction.fulfilled.toString()]: (
      state: ThinksToDoType,
      { payload }
    ) => {
      const { success, message, total_count, status_code,total_target_entries} = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        approvedInvoiceTotalCount:total_count?+total_count:0,
        usersWeeklyApprovedInvoiceTotalCount:total_target_entries
      };
    },
    [getWeeklyApprovedUsersInvoiceEntriesCountAction.rejected.toString()]: (
      state: ThinksToDoType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }), 
    [getRegularizeApprovalPendingListAction.pending.toString()]: (
      state: ThinksToDoType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getRegularizeApprovalPendingListAction.fulfilled.toString()]: (
      state: ThinksToDoType,
      { payload }
    ) => {
      const { success, message, result, status_code} = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        regularizeApprovalPendingList:result
      };
    },
    [getRegularizeApprovalPendingListAction.rejected.toString()]: (
      state: ThinksToDoType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }), 
    [approveOrRejectRegularizeAction.pending.toString()]: (
      state: ThinksToDoType
    ) => ({
      ...state,
      updateFetching: true,
    }),
    [approveOrRejectRegularizeAction.fulfilled.toString()]: (
      state: ThinksToDoType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
          updateFetching: false,
        };
      }
      return {
        ...state,
        updateFetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [approveOrRejectRegularizeAction.rejected.toString()]: (
      state: ThinksToDoType,
      { error }
    ) => ({
      ...state,
      updateFetching: false,
      success: 0,
      error: error?.message,
    }),
  },
});

export const {
  resetScheduledUpcomingInterviewsList,
  resetThinksToDoSuccess,
  resetThinksToDoError,
  resetThinksToDoMessage,
  resetThinksToDoStatusCode,
  resetThinksToDoUpdateFetching,
  resetJobClosureListData,
  resetJobClosureTotalCount,
  resetJobClosureListForRM,
  resetTotalCountRM,
  resetJobClosureRatingList,
  resetUnApprovedInvoiceCountData,
  resetUnApprovedInvoiceTotalCount,
  resetUsersWeeklyApprovedInvoiceTotalCount,
  resetRegularizeApprovalPendingList
} = thinksToDoSlice.actions;
